import React, { useEffect } from 'react';
import { SignedIn, SignedOut, useAuth } from '@clerk/clerk-react';
import { ArrowRight, Briefcase, Users, Lock } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
// import FileUploadSection from './FileUploadSection';
import AlgoHeadsBenefits from './AlgoheadsBenefits';
import NetworkGraph from './NetworkGraph';
import JobSearchFlow from './JobSearchFlow';
import CareersComponent from './Careers';

const LandingPage = ({ onUploadComplete, apiUrl }) => {
  const navigate = useNavigate();
  const { isSignedIn } = useAuth();
  
  useEffect(() => {
    if (isSignedIn) {
      navigate('/dashboard');
    }
  }, [isSignedIn, navigate]);

  const handleSignIn = () => {
    navigate('/sign-in');
  };

  return (
    <SignedOut>
      <div className="landing-page">
        {/* Hero Section */}
        <section className="hero-container">
          <div className="hero-content">
            <h1>Stop Searching – Let Your Network Bring You the Jobs You're Already Connected To!</h1>
            <p className="sub-headline">
              Algoheads flips the job search around. We show you relevant openings <em>only</em> at companies where your LinkedIn connections already work, matching you instantly.
            </p>
            
            {/* <SignedIn>
              <FileUploadSection onUploadComplete={onUploadComplete} apiUrl={apiUrl} />
            </SignedIn> */}
            
            <button
              className="cta-button"
              onClick={handleSignIn}
            >
              Find Your First Referral Opportunity Now
              <ArrowRight size={18} className="arrow-icon" />
            </button>
            
            <div className="trust-signals">
              <div className="trust-item">
                <Lock size={16} />
                <span>Connect securely via LinkedIn</span>
              </div>
              <div className="trust-divider">|</div>
              <div className="trust-item">
                <Users size={16} />
                <span>Read-only access</span>
              </div>
            </div>
          </div>
          <div className="hero-visual">
            <NetworkGraph />
          </div>
        </section>
        
        {/* Job Search Flow Diagram */}
        <JobSearchFlow />
        
    
        
        <div>
          <CareersComponent />
        </div>
        <div>
          <AlgoHeadsBenefits />
        </div>
      </div>
    </SignedOut>
  );
};

export default LandingPage;